import { getType } from 'typesafe-actions';
import { produce } from 'immer';

import { ActionsOf } from '../../../helpers/actions';
import * as commandsActions from './actions';

import { ListCommand } from '../../../components/modules/commands/types';
import { TableCommandResponse } from '../../../components/ui/commandUI/table';

export interface CommandsData {
  commands: ListCommand[];
  loading: boolean;
  error: boolean;
  siteId: number;
  response?: string | TableCommandResponse;
  loadingResponse?: boolean;
  errorResponse?: boolean;
  success?: boolean;
}

const initialState: CommandsData = {
  commands: [],
  loading: false,
  error: false,
  siteId: -1,
  response: '',
  loadingResponse: false,
  errorResponse: false,
  success: false,
};

type CommandsActions = ActionsOf<typeof commandsActions>;

export const commandsEntityReducer = produce((draft, action: CommandsActions) => {
  switch (action.type) {
    case getType(commandsActions.getCommands.request): {
      draft.siteId = action.payload.siteId;
      draft.loading = true;
      draft.error = false;

      return;
    }
    case getType(commandsActions.getCommands.success): {
      const { result } = action.payload as { result: ListCommand[] };

      draft.commands = result;
      draft.loading = false;

      return;
    }

    case getType(commandsActions.getCommands.error): {
      draft.loading = false;
      draft.error = true;

      return;
    }

    case getType(commandsActions.runCommand.request): {
      draft.response = '';
      draft.loadingResponse = true;
      draft.errorResponse = false;
      draft.success = false;

      return;
    }

    case getType(commandsActions.runCommand.success): {
      const { result } = action.payload as { result: string | TableCommandResponse };
      draft.response = result;
      draft.loadingResponse = false;
      draft.errorResponse = false;
      draft.success = true;

      return;
    }

    case getType(commandsActions.runCommand.error): {
      draft.loadingResponse = false;
      draft.errorResponse = true;
      draft.success = false;

      return;
    }
  }
}, initialState);
